import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { logout, setAuthState, defaultAuthState } from "../../app/auth";

function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    logout().finally(() => {
      dispatch(setAuthState(defaultAuthState()));
      navigate("/");
    });
  }, [navigate, dispatch]);

  return (
    <Typography variant="h6">
      Please wait while you are being logged out...
    </Typography>
  );
}

export default Logout;
